import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModifiedActionStatus } from 'apps/website/src/app/utils/public-api';
import { environment } from 'apps/website/src/environments/environment';
import { DataField } from '../table-ui/table-ui.component';
export interface DialogTableDataFields {
  fieldName: string,
  label: string,
  attachment?: boolean,
  statusField?: boolean,
  tableView?: boolean,
  html?: boolean,
  tableDataFields?: DataField[],
  tableData?: any[],
  actions?: ActionConfig[],
  rowonly?: boolean,
  eLink?: boolean
}
export interface ActionConfig {
  label: string;
  action: () => void;
  condition: boolean;
  type?: string; // e.g. 'primary', 'danger', 'success'
}

@Component({
  selector: 'intrasense-view-team-detail',
  templateUrl: './view-team-detail.component.html',
  styleUrls: ['./view-team-detail.component.scss']
})
export class ViewTeamDetailComponent implements OnInit {
  title!: string;
  dialogDataFields: DialogTableDataFields[] = [];
  dataArr: any[] = [];
  assetsPathUrl = environment.assetsPathUrl;
  ModifiedActionStatus = ModifiedActionStatus;

  constructor(
    private dialogRef: MatDialogRef<ViewTeamDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { fields: DialogTableDataFields[], title: string, sourceData: any[], actions: ActionConfig[] },
  ) { }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 1200) {
      this.dialogRef.updateSize('40%');
    } else {
      this.dialogRef.updateSize('100%');
    }
  }

  ngOnInit(): void {
    if (window.innerWidth > 1200) {
      this.dialogRef.updateSize('40%');
    } else {
      this.dialogRef.updateSize('100%');
    };

    if (this.data.fields && this.data.title && this.data.sourceData) {
      this.title = this.data.title ? this.data.title : '';
      this.dataArr = this.data.sourceData.length > 0 ? this.data.sourceData : [];
      this.dialogDataFields = this.data.fields.length > 0 ? this.data.fields : [];
    }
  }


  // close popup
  close() {
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInUp");
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutDown");
    setTimeout(() => { this.dialogRef.close(); }, 500);
  }

  previewImage(url: string) {
    if (url) {
      window.open(this.assetsPathUrl + url);
    }
  }

  openeLink(url: string) {
    if (url) {
      window.open(url);
    }
  }

}
